import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'
import Nouveautes from '@/components/nouveautes'
import api from '@/api/api';
import { genders } from '@/utils/constants';
import Pusher from 'pusher-js';
import audioFile from '@/assets/audios/notification.mp3';
import ManagePatientModal from '@/components/dashboard/liste-patients/manage-patient';
import { estAgentSecurite } from '@/utils/portail-sorties';
import store_patient from '@/store/mods/clinique/patients'


export default {
    name: "navbar",
    components: {
        Nouveautes,
        ManagePatientModal
    },
    props: { sidebarCollapsed: Boolean },
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            all_apps: false,
            menu_state: 0,

            vm_state: open_menu_state,
            counter: 0,
            remaining_time: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            is_close: 0,

            queue: [],
            isLoading: false,
            removingId: null,
            patient_data: undefined,
            sexes: genders,
            current_queue: undefined,
            queue_loading: true
        };
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        auth_user() {
            return this.$store.getters['auth_user'];
        },

        sortedRoles() {
            const roles = this.auth_user && Array.isArray(this.auth_user.roles) ? this.auth_user.roles : []
            return roles.slice().sort((a, b) => Number(!!this.activeRole && b.nom === this.activeRole.nom) - Number(!!this.activeRole && a.nom === this.activeRole.nom))
        },

        activeRoleLabel() {
            const selected = this.sortedRoles.find(role => this.activeRole && role.nom === this.activeRole.nom)
            return selected ? selected.description : (this.auth_user && this.auth_user.titre) || ''
        },

        refresh() {
            return this.$store.getters['refresh'];
        },

        countdown_info() {
            return this.$store.getters['countdown_info'];
        },

        // PORT-001 : l'agent de sécurité n'interroge pas la file d'attente et ne s'abonne pas à Pusher.
        mode_portail() {
            return estAgentSecurite(this.$store.getters['authInfo'], this.$store.getters['activeRole']);
        }
    },

    watch: {
        // PORT-001 : passage au rôle agent pendant que la barre est affichée → connexion Pusher fermée.
        mode_portail(actif) {
            if (actif) this.fermerPusher();
        }
    },

    created() {
        // Instance Pusher hors data (non réactive), fermée à la destruction de la barre.
        this.client_pusher = null;
        if (!this.mode_portail) this.subscribe();
    },

    mounted() {
        this.$store.dispatch('getCountDown').then(() => {
            this.calcTimeRemaining()
        })

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            this.$store.dispatch("getAuthUser", { user_id: this.user_id })
        }

        this.getCurrencyInfo()


        this.handleDocumentClick = (e) => {
            let $clicked = $(e.target);

            if (!$clicked.parents().hasClass("menu-container")) {
                if (this.vm_state != 0) {
                    this.openMenu(this.vm_state, 'user-menu')
                }
            }

            if (!$clicked.parents().hasClass("menu-container")) {
                if (this.menu_state != 0) {
                    $('.all-apps').removeClass('animate-zoomIn');
                    $('.all-apps').addClass('animate-zoomOut');
                    $('.all-apps').fadeOut();
                    this.menu_state = 0;
                }

            }
        }
        $(document).on('click', this.handleDocumentClick);
        // La capture fonctionne aussi quand un autre panneau arrête la propagation du clic.
        this.handleProfileOutsidePointer = (event) => {
            const switcher = this.$refs && this.$refs.profileSwitcher
            if (switcher && switcher.open && !switcher.contains(event.target)) this.closeRoleMenu()
        }
        this.handleProfileEscape = (event) => {
            if (event.key === 'Escape') this.closeRoleMenu()
        }
        document.addEventListener('pointerdown', this.handleProfileOutsidePointer, true)
        document.addEventListener('keydown', this.handleProfileEscape, true)

        // Listen for closeSidebar event from sidebar component
        this.$root.$on('closeSidebar', () => {
            if (this.is_close == 1) {
                this.toggleSidebar();
            }
        });

        if (!this.mode_portail) this.fetchQueue();
    },

    beforeDestroy() {
        // Clean up event listener
        clearTimeout(this.roleMenuTimer)
        clearInterval(this.minuteurLicence)
        $(document).off('click', this.handleDocumentClick);
        document.removeEventListener('pointerdown', this.handleProfileOutsidePointer, true)
        document.removeEventListener('keydown', this.handleProfileEscape, true)
        this.$root.$off('closeSidebar');
        // PORT-001 : la coque du portail remplace la barre ; sans cela, la connexion Pusher survit (son de « scan »).
        this.fermerPusher();
    },

    methods: {
        toggleRoleMenu() {
            const switcher = this.$refs.profileSwitcher
            if (!switcher) return
            if (switcher.classList.contains('is-closing')) {
                clearTimeout(this.roleMenuTimer)
                switcher.classList.remove('is-closing')
            } else if (switcher.open) {
                this.closeRoleMenu()
                return
            }
            switcher.open = true
        },
        closeRoleMenu() {
            const switcher = this.$refs && this.$refs.profileSwitcher
            if (!switcher || !switcher.open || switcher.classList.contains('is-closing')) return
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                switcher.open = false
                return
            }
            switcher.classList.add('is-closing')
            this.roleMenuTimer = setTimeout(() => {
                switcher.open = false
                switcher.classList.remove('is-closing')
            }, 180)
        },
        calcTimeRemaining() {
            this.counter = this.countdown_info.duree_restant.total_secondes

            // Un seul décompte par barre : l'ancien continuait de tourner après chaque remontage (connexion, portail).
            clearInterval(this.minuteurLicence)
            this.minuteurLicence = setInterval(() => {
                let total_seconds = this.counter;

                // Convert the remaining time back to days, hours, minutes, and seconds
                let remaining_days = Math.floor(total_seconds / (24 * 60 * 60));
                total_seconds %= (24 * 60 * 60);

                let remaining_hours = Math.floor(total_seconds / (60 * 60));
                total_seconds %= (60 * 60);

                let remaining_minutes = Math.floor(total_seconds / 60);
                let remaining_seconds = total_seconds % 60;

                this.remaining_time = {
                    days: remaining_days,
                    hours: remaining_hours,
                    minutes: remaining_minutes,
                    seconds: remaining_seconds
                }

                this.counter -= 1
            }, 1000)
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector) {
            this.vm_state = openMenu.dropMenu(state, selector)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector) {
            this.vm_state = closeMenu.wrapMenu(selector)
        }, 

        resetVuexState() {
            const freshState = {};
            const modules = this.$store._modules.root._children || {};

            Object.keys(modules).forEach((moduleName) => {
                const module = modules[moduleName];
                const moduleState = typeof module.state === 'function' ? module.state() : module.state;

                freshState[moduleName] = moduleState && typeof moduleState === 'object'
                    ? { ...moduleState }
                    : moduleState;
            });

            this.$store.replaceState(freshState);
        },

        async logout()
        {
            store_patient.invaliderListePatients()
            this.resetVuexState();
            localStorage.removeItem('vuex');
            localStorage.clear();
            this.$router.push({"path": "/login"})
        },

        switchRole: function (userId, roleId, roleNom) {
            if (roleNom == 'ROLE_RESPONSABLE_LOGISTIQUE') {
                window.location = String(this.base_url_stock || '').replace(/\/+$/, '') + '/espaces'
            } else if (roleId == 2 || roleId == 3 || roleId == 7 || roleId == 16 || roleId == 17) {
                window.location = this.base_url_clinique
            } else if (roleId == 9 || roleId == 6) {
                window.location = this.base_url_stock
            } else if (roleId == 11) {           // ROLE_RH
                window.location = this.base_url_rh
            } else {
                this.$store.dispatch('switchRole', { userId: userId, roleId: roleId }).then(() => {
                    if (roleId == 1 || roleId == 5) {
                        this.$router.push({ "path": "/tableau-de-bord" })
                    } else if (roleId == 14) {
                        this.$router.push({ "path": "/tresorerie" })
                    } else {
                        this.$router.push({ "path": "/" })
                    }
                })
            }
        },

        getCurrencyInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'currency')
        },

        toggleSidebar() {
            this.is_close = (this.is_close == 0) ? 1 : 0

            if (this.is_close == 1) {
                $('.sidebar').addClass('shw-sdbar');
            } else {
                $('.sidebar').removeClass('shw-sdbar');
            }
        },

        subscribe() {
            // Enable pusher logging - don't include this in production
            //   Pusher.logToConsole = true;

            if (!this.PUSHER_APP_KEY) {
                // Clé Pusher non configurée — on désactive proprement l'abonnement
                // au lieu de planter avec "You must pass your app key when you instantiate Pusher".
                console.warn('[Pusher] VUE_APP_PUSHER_APP_KEY non défini — abonnement scan désactivé.')
                return
            }

            this.fermerPusher()
            let pusher = new Pusher(this.PUSHER_APP_KEY, { cluster: this.PUSHER_APP_CLUSTER })
            this.client_pusher = pusher
            pusher.subscribe('consultations')
            pusher.bind('scan', data => {
                // Check if data.id already exists in the queue
                let duplicate = this.queue.find(item => item.id === data.id);

                // If it doesn't exist, add it to the queue
                console.log("Scan data:", data);
                
                if (!duplicate) {
                    this.queue.push(data);
                    this.playAudio();
                }
            })
            pusher.bind('queue-removed', data => {
                this.queue = this.queue.filter(item => item.id !== data.id);
            })
        },

        // PORT-001 : ferme la connexion Pusher de la barre (destruction, ou rôle agent de sécurité).
        fermerPusher() {
            const pusher = this.client_pusher
            this.client_pusher = null
            if (!pusher) return
            try {
                if (typeof pusher.unbind_all === 'function') pusher.unbind_all()
                if (typeof pusher.disconnect === 'function') pusher.disconnect()
            } catch (erreur) {
                // Connexion déjà fermée : rien à faire.
            }
        },

        playAudio() {
            try {
                const audio = new Audio(audioFile);
                audio.play();
            } catch (error) {
                console.error('Error playing audio:', error);
            }
        },

        async fetchQueue() {
            this.queue_loading = true
            const response = await api.clinique().get('/cca-mobile/queues');
            
            console.log('Queue data:', response);
            if (response.status === 200) {
                this.queue = response.data;
            }
            this.queue_loading = false
        },

        onQueueClick(queue) {
            this.current_queue = queue;
            if (queue.status != 'processing') {
                this.updateQueue(queue.id);
            }
            this.closeMenu('queue-dropdown', 'animate-fadeInTop', 'animate-fadeOutTop');

            $('.edit-profil').modal('show');

            this.fetchSimilarPatients(queue.mobile_user.id);
        },

        async updateQueue(id) {
            const response = await api.clinique().put(`/cca-mobile/queues/${id}`, { status: 'processing' });

            if (response.status === 200) {
                // console.log('updateQueue:', response.data);
            }

        },

        async fetchSimilarPatients(mobile_user_id) {
            this.isLoading = true;


            try {
                const response = await api.clinique().get(`/cca-mobile/patients/${mobile_user_id}/similars`);

                if (response.status === 200) {
                    this.isLoading = false;
                    let ccaPatient = response.data.locale_patient;
                    let mobileProfile = response.data.online_patient;

                    if (mobileProfile) {
                        $('.edit-profil-navbar').modal('show');
                        this.transformProfileToPatientData({
                            ...mobileProfile,
                            fullnameExists: ccaPatient.fullnameExists,
                            birthdateExists: ccaPatient.birthdateExists,
                            exists: ccaPatient.phoneExists && (ccaPatient.fullnameExists || ccaPatient.birthdateExists),
                        });
                    } else {
                        console.log('ccaPatient', ccaPatient)
                        console.log('mobileProfile', mobileProfile)
                    }
                }
            } catch (error) {
                if (error.response) {
                    this.dangerToast('Une erreur est survenue lors de la récupération des informations du patient', 'error');
                }
                $('#create-new-patient-mobile').modal('hide');
            }
        },

        transformProfileToPatientData(profile) {
            const {
                patient_lastname,
                patient_firstname,
                patient_gender,
                patient_age,
                patient_birthdate,
                patient_birthplace,
                patient_phone,
                patient_adresse,
                patient_profession,
                patient_idcard_type,
                patient_idcard_num,
                patient_nationality,
                patient_email,
            } = profile;

            const genderObject = this.sexes.find(sexe => sexe.specificatif === patient_gender);

            this.patient_data = {
                type_patient: "non_assure",
                country_suffix: this.default_country_code,
                matricule: "",
                nom: patient_lastname || "",
                prenoms: patient_firstname || "",
                sexe: genderObject,
                age: patient_age || "",
                date_naissance: patient_birthdate || "",
                lieu_de_naissance: patient_birthplace || "",
                telephone: this.formatPhoneNumber(patient_phone),
                quartier: patient_adresse || "",
                profession: patient_profession || "",
                numero_cni: patient_idcard_type === 'national_id_card' ? patient_idcard_num : "",
                numero_passeport: patient_idcard_type === 'passport' ? patient_idcard_num : "",
                nationalite: patient_nationality || "",
                email: patient_email || "",
                ...this.initAccompagnantData(),
                ...this.getPersonneAPrevenirData(profile),
                exists: profile.exists,
                fullnameExists: profile.fullnameExists,
                birthdateExists: profile.birthdateExists,
            };
        },
        
        getPersonneAPrevenirData(profile) {
            const [lastname, firstname] = (profile.contact_person_name || '').split(' ');

            return {
                personne_a_prevenir_nom: lastname || "",
                personne_a_prevenir_prenom: firstname || "",
                personne_a_prevenir_phone: this.formatPhoneNumber(profile.contact_person_phone),
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_profession: "",
            };
        },

        initAccompagnantData() {
            return {
                accompagnant_nom: "",
                accompagnant_prenom: "",
                accompagnant_phone: "",
                accompagnant_filiation: "",
                accompagnant_quartier: "",
                accompagnant_profession: "",
            };
        },

        formatPhoneNumber(phoneNumber) {
            return phoneNumber?.replace(/^\+\d{1,3}/, '') || "";
        },

        paginatePhoneNumber(phoneNumber) {
            const countryCode = phoneNumber.substring(0, 4);
            const phoneNumberWithoutCountryCode = phoneNumber.substring(4);

            const formattedPhoneNumber = phoneNumberWithoutCountryCode.replace(/(\d{2})(?=\d)/g, '$1 ');

            return `${countryCode} ${formattedPhoneNumber}`;
        },

        async onSuccessfullySavedPatient(data) {
            this.$store.dispatch('setRefresh', !this.refresh);
            this.queue = this.queue.filter(item => item.id !== this.current_queue?.id);

            if (this.current_queue !== undefined) {
                await api.clinique().put(`/cca-mobile/queues/${this.current_queue?.id}`, { status: 'completed', patient_id: data.id });
            }
        },

        /**
         * Retire un patient de la file d'attente Scan & Go (entrée abandonnée / non traitée).
         * Côté backend, l'entrée queue est supprimée et — si elle n'a jamais été liée à un
         * dossier patient — la fiche mobile orpheline aussi, ce qui débloque un re-scan ultérieur.
         */
        async removeFromQueue(q) {
            if (!q || this.removingId === q.id) return;

            console.log("mobile user: ",q.mobile_user);
            

            const fullName = `${q.mobile_user?.lastname || ''} ${q.mobile_user?.firstname || ''}`.trim();
            if (!window.confirm(`Retirer ${fullName || 'ce patient'} de la file d'attente ?`)) return;

            this.removingId = q.id;
            try {
                const response = await api.clinique().delete(`/cca-mobile/queues/${q.id}`);
                if (response.status === 200) {
                    this.queue = this.queue.filter(item => item.id !== q.id);
                    this.successToast('Patient retiré de la file d\'attente.', 'success');
                }
            } catch (error) {
                const message = error.response?.data?.message || 'Impossible de retirer ce patient de la file d\'attente.';
                this.dangerToast(message, 'error');
            } finally {
                this.removingId = null;
            }
        }
    }
};
